<template>
  <component :is="el" :label="label" :required="required">

   <span v-if="noForm">{{label}}&nbsp;</span>
    <el-select
      v-model="val"
      :disabled="disabled"
      :placeholder="placeholder"
      value-key="value"
      :size="size"
      @change="updated">

      <el-option
        v-for="item in contacts"
          :key="item.id"
          :label="item.name"
          :value="item.id">
      </el-option>

    </el-select>

  </component>
</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [ArrayMixins, PostMixins],

  props: {
    label: {
      type: String,
      default: 'Contacts'
    },
    orgId: {
      type: Number,
      default: null
    },
    value: {
//      type: String,
      required: true
    },
    type: {
      type: [Array, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Contact'
    },
    helpText: {
      type: String,
      default: null
    },
    fullObject: {
      type: Boolean,
      default: false
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {

    refresh () {
      this.fetch(this.oId)
    },

    fetch (id) {

      if (id) {
        this.contacts = []
        this.fetchData('contacts/org/' + id + '/select', this.success, 'contacts')
      }

    },

    success (data) {
      this.contacts = data
    },

    updated (value) {
      this.val = value
      let obj = this.find('id', value, this.contacts)

      this.$emit('input', this.fullObject ? obj : this.val)
      this.$emit('change', obj)
    }

  },


  watch: {

    orgId: function (id) {
      this.oId = id
      this.fetch(this.oId)
    }

  },


  data () {
    return {
      val: this.value,
      oId: this.orgId,
      el: this.noForm ? 'div' : 'el-form-item',
      contacts: []
    }
  },

  mounted () {
    this.fetch(this.orgId)
  }
}
</script>

<stype scoped>
  .el-select {
    display: inline-block;
    width: 100%;
  }
</style>
